/**
 * Asynchronously loads the component for HomePage
 */

import * as React from 'react';
import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';
import styled from 'styled-components/macro';

const LoadingWrapper = styled.div`
   width: 100%;
   height: 80vh;
   display: flex;
   align-items: center;
   justify-content: center;
 `;

export const Data = lazyLoad(
    () => import('./index'),
    module => module.Data,
    {
        fallback: (
            <LoadingWrapper>
                <LoadingIndicator />
            </LoadingWrapper>
        ),
    },
);
